export const formatCurrency = (value) => {
  if (value === null || value === undefined) {
    return '';
  }
  const number = typeof value === 'string' ? parseFloat(value.replace(/\./g, '').replace(',', '.')) : value;
  if (isNaN(number)) {
    return '';
  }
  return number.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
};

export const parseCurrency = (value) => {
  if (!value) {
    return 0;
  }
  return parseFloat(value.replace(/R\$\s?/, '').replace(/\./g, '').replace(',', '.'));
};

export const formatInputCurrency = (value) => {
  if (!value) return '';
  let onlyNumbers = value.replace(/[^\d]/g, '');
  if (!onlyNumbers) return '';

  // Pad with zeros if less than 3 digits
  onlyNumbers = onlyNumbers.padStart(3, '0');

  const integerPart = onlyNumbers.slice(0, -2).replace(/^0+/, '') || '0';
  const decimalPart = onlyNumbers.slice(-2);
  
  const formattedIntegerPart = parseInt(integerPart, 10).toLocaleString('pt-BR');

  return `R$ ${formattedIntegerPart},${decimalPart}`;
};
